import { apiService } from './api';

interface LoginResponse {
  user: {
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    is_verified: boolean;
    is_admin: boolean;
    telegram_chat_id?: string;
  };
  access_token: string;
}

interface RegisterData {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
}

interface ForgotPasswordData {
  email: string;
}

interface ResetPasswordData {
  token: string;
  password: string;
}

interface VerifyEmailData {
  token: string;
}

class AuthService {
  async login(email: string, password: string): Promise<LoginResponse> {
    return apiService.post<LoginResponse>('/auth/login', { email, password });
  }

  async register(userData: RegisterData): Promise<{ message: string }> {
    return apiService.post<{ message: string }>('/auth/register', userData);
  }

  async forgotPassword(data: ForgotPasswordData): Promise<{ message: string }> {
    return apiService.post<{ message: string }>('/auth/forgot-password', data);
  }

  async resetPassword(data: ResetPasswordData): Promise<{ message: string }> {
    return apiService.post<{ message: string }>('/auth/reset-password', data);
  }

  async verifyEmail(data: VerifyEmailData): Promise<{ message: string }> {
    return apiService.post<{ message: string }>('/auth/verify-email', data);
  }

  async getCurrentUser(): Promise<LoginResponse['user']> {
    return apiService.get<LoginResponse['user']>('/auth/me');
  }

  async updateProfile(userData: Partial<RegisterData>): Promise<LoginResponse['user']> {
    return apiService.put<LoginResponse['user']>('/auth/profile', userData);
  }

  async updateTelegramChatId(chatId: string): Promise<{ message: string }> {
    return apiService.put<{ message: string }>('/auth/telegram', { telegram_chat_id: chatId });
  }
}

export const authService = new AuthService(); 